// Secrets and easter eggs as data (docs/06 §8). Feeding the machine one symbol often enough across the
// save gets a unique line and a permanent change to that symbol.
export interface FedSecret {
  /** The symbol fed. */
  defId: string;
  /** Lifetime count at which it triggers (once). */
  count: number;
  /** meta.flags key that remembers it. */
  flag: string;
  /** i18n key of the Maw's line. */
  line: string;
  /** Permanent flat VALUE for that symbol afterwards. */
  valueAdd: number;
}

export const FED_SECRETS: FedSecret[] = [{ defId: 'cherry', count: 77, flag: 'sickOfCherries', line: 'maw.secret.sickOfCherries', valueAdd: 1 }];

/** Typed on the title screen: the logo chomps. */
export const TITLE_CODE = 'feed';
